import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

export const trackPreviewImgClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'lead form',
        eventAction: 'clickthrough',
        eventLabel: 'listing_image',
        eventValue: 1
    });
};

export const trackPreviewDescriptionClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'lead form',
        eventAction: 'clickthrough',
        eventLabel: 'listing_text',
        eventValue: 1
    });
};

export const trackPreviewBranchClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'Enquiry',
        eventAction: 'clickthrough',
        eventLabel: 'Agent block',
        eventValue: 0
    });
};
